//
//
//
//
//
//
//
//
//
//
//
import ContentMain from "./Pages/ContentMain";
import NotInstall from "./Pages/NotInstall";
import ContentFrame from "./Pages/ContentFrame";
import AntiVirus from "./Pages/AntiVirus";
import AboutUs from "./Pages/AboutUs";
export default {
  props: ['brand', 'userAgent', 'activeContent', 'extensions', 'defaultExtensions', 'url', 'domain'],
  name: "Content",
  data: function data() {
    return {
      status: 'main',
      subOpen: ''
    };
  },
  methods: {
    installExtension: function installExtension(extensionsType) {
      this.$parent.installExtension(extensionsType);
    },
    isInstalledByType: function isInstalledByType(extensionsType) {
      return this.$parent.isInstalledByType(extensionsType);
    },
    activeContentChange: function activeContentChange(content, type) {
      this.$parent.activeContentChange(content, type);
    }
  },
  components: {
    NotInstall: NotInstall,
    ContentFrame: ContentFrame,
    ContentMain: ContentMain,
    AntiVirus: AntiVirus,
    AboutUs: AboutUs
  },
  watch: {
    activeContent: {
      handler: function handler(val) {
        if (this.isInstalledByType(val.type)) {
          this.status = 'frame';
          var extension = this.$parent.findExtensionByType(val.type);

          if (val.type == 'pdf') {
            var extraParam = '';

            if (this.url.searchParams.get('link')) {
              extraParam = '?link=' + this.url.searchParams.get('link');
            } else if (this.url.searchParams.get('linkDirect')) {
              extraParam = '?link=' + this.url.searchParams.get('linkDirect');
            }

            this.activeContent.main.src = '/PDFframe/frame.html' + extraParam;
            return;
          }

          this.activeContent.main.src = 'chrome-extension://' + extension.id + '/frame/frame.html';
          return;
        }

        if (val.length == 0) {
          this.status = 'main';
          return;
        } else if (val.type == 'speed_test') {
          this.status = 'frame';
          return;
        } else if (val.type == 'anti_virus') {
          this.status = 'anti_virus';
          return;
        } else if (val.type == 'about_us') {
          this.subOpen = this.activeContent.subOpen;
          this.status = 'about_us';
          return;
        }

        this.status = 'not-install';
      },
      deep: true,
      immediate: true
    }
  }
};